import { createSelector } from 'reselect';
import { stateSelectorSwitcher } from '../utils/selectorUtils';
export const getTheme = state => stateSelectorSwitcher(state, 'theme');
export const getEditorPreivew = createSelector([getTheme], theme => theme.editorPreview);
export const getThemeName = createSelector([getTheme], theme => theme.name);
export const getThemePath = createSelector([getTheme], theme => theme.path);
export const getThemePreviewAbsolutePath = createSelector([getTheme], theme => theme.previewAbsolutePath);
export const getThemeMessages = createSelector([getTheme], theme => theme.messages);
export const getThemeFields = createSelector([getTheme], theme => theme.fields);
export const getThemeSettingsValuesId = createSelector([getTheme], theme => theme.settingsValuesId);
export const getThemeResponsiveBreakpoints = createSelector([getTheme], theme => {
  return theme && theme.responsiveBreakpoints ? theme.responsiveBreakpoints : [];
});
export const getThemeResponsiveBreakpointsByName = createSelector([getThemeResponsiveBreakpoints], responsiveBreakpoints => {
  // const responsiveBreakpointsList = [
  //   {
  //     name: 'mobile',
  //     previewWidth: { value: 500, units: 'px' },
  //     mediaQuery: '@media (max-width: 720px)',
  //   },
  //   {
  //     name: 'tablet',
  //     mediaQuery: '@media (max-width: 1080px)',
  //     previewWidth: { value: 720, units: 'px' },
  //   },
  //   {
  //     name: 'custom_breakpoint',
  //     label: 'Custom breakpoint',
  //     description: 'This is a custom breakpoint.',
  //     mediaQuery: '@media (max-width: 767px)',
  //     previewWidth: { value: 1000, units: 'px' },
  //   },
  // ];

  // return responsiveBreakpointsList.reduce(
  //   (acc: Record<string, ResponsiveBreakpoint>, breakpoint) => {
  //     const { name } = breakpoint;
  //     acc[name] = breakpoint;
  //     return acc;
  //   },
  //   {}
  // );

  return responsiveBreakpoints.reduce((acc, breakpoint) => {
    acc[breakpoint.name] = breakpoint;
    return acc;
  }, {});
});
export const getThemeSelectorsMap = createSelector([getEditorPreivew], editorPreview => {
  return editorPreview && editorPreview.selectors ? editorPreview.selectors : {};
});
export const getThemeImageUrl = createSelector([getTheme], theme => theme.imageUrl);